import { useRef } from 'react'
import isEqual from 'lodash/isEqual'


const useDeepMemo = (memoFn, key) => {
  const ref = useRef()

  if (!ref.current || !isEqual(key, ref.current.key)) {
    ref.current = { key, value: memoFn() }
  }

  return ref.current.value
}


export default useDeepMemo
